import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { useTexts } from "@/lib/layout";

export default function NotFound() {
  const t = useTexts("notfound");
  return (
    <div className="wrap py-24 md:py-32 grid md:grid-cols-12 gap-8 items-end" data-testid="not-found-page">
      <Seo title={t.seo_title || ""} description={t.text} noindex />
      <p className="md:col-span-5 font-display font-black text-[9rem] sm:text-[12rem] leading-none text-primary tracking-tighter">{t.code}</p>
      <div className="md:col-span-7 pb-6">
        <h1 className="font-display font-black text-4xl sm:text-5xl leading-tight" data-testid="not-found-title">{t.title}</h1>
        <p className="mt-4 text-lg text-muted-foreground">{t.text}</p>
        <Link to="/" className="kicker mt-8 inline-block border-2 border-foreground px-7 py-3.5 hover:bg-foreground hover:text-background transition-colors" data-testid="not-found-home-link">
          {t.button}
        </Link>
      </div>
    </div>
  );
}
